module.exports = __webpack_public_path__ + "img/LOGO_TEXTE_blanc.dd967565.png";